import { DatabaseFieldType } from '@databases/types/database';
import { type ReactNode } from 'react';
import { createContentColumnFieldReadModule } from '../content-column-field-read-module.ts';
import { type ContentColumnReadPolicy } from '../content-column-read.ts';
import {
  EMPTY_PAGE_LABELS_CONTENT,
  type PageLabelsReadContent
} from './page-labels-read-content.ts';

export type PageLabelsReadPolicy = ContentColumnReadPolicy;
export type PageLabelsReadRenderer = (content: PageLabelsReadContent) => ReactNode;
/**
 * Labels use the same datasource presentation and reference semantics as V1 details.
 */
export function createPageLabelsFieldReadModule(
  options?: PageLabelsReadPolicy & { readonly render?: PageLabelsReadRenderer }
) {
  return createContentColumnFieldReadModule(
    {
      fieldType: DatabaseFieldType.PAGE_LABELS,
      emptyContent: EMPTY_PAGE_LABELS_CONTENT,
      getColumn: () => 'labels'
    },
    options
  );
}
